function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { CoreVideoInternal } from '../../core-video-internal';
import { getUserAgent } from '../../core/device/device-recognition';
import { AdsFailoverReason } from '../../core/player/playout-data';
import { TestingOverrides } from '../../core/services/testing-overrides';
import { TelemetryNotificationKey } from '../../core/telemetry/telemetry-session';
import { CvsdkError, ErrorSeverity } from '../../error';
import { sdkLogger } from '../../logger';
import { PerfKey, perfLogger, PerfTag } from '../../utils/perf';
import { checkIsSessionItemSleAutoplayType } from '../../utils/playback-type';
export var AdvertsVacStageManager = /*#__PURE__*/ function() {
    "use strict";
    function AdvertsVacStageManager(adInsertionClientConfig, session, adInsertionAddon, adInsertionConfig, isVacEnabled, vacAddon, isNativeCsai, isPrefetch) {
        _class_call_check(this, AdvertsVacStageManager);
        _define_property(this, "adInsertionClientConfig", void 0);
        _define_property(this, "session", void 0);
        _define_property(this, "adInsertionAddon", void 0);
        _define_property(this, "adInsertionConfig", void 0);
        _define_property(this, "isVacEnabled", void 0);
        _define_property(this, "vacAddon", void 0);
        _define_property(this, "isNativeCsai", void 0);
        _define_property(this, "isPrefetch", void 0);
        _define_property(this, "logger", void 0);
        this.adInsertionClientConfig = adInsertionClientConfig;
        this.session = session;
        this.adInsertionAddon = adInsertionAddon;
        this.adInsertionConfig = adInsertionConfig;
        this.isVacEnabled = isVacEnabled;
        this.vacAddon = vacAddon;
        this.isNativeCsai = isNativeCsai;
        this.isPrefetch = isPrefetch;
        this.logger = sdkLogger.withContext('AdvertsVacStageManager');
    }
    _create_class(AdvertsVacStageManager, [
        {
            key: "fetchVacData",
            value: function fetchVacData(sessionItem, initialPlayoutData) {
                var _this = this;
                return _async_to_generator(function() {
                    var // "Populated" playout data has additional data required for ads e.g. VAM or adsFailoverReason
                    populatedPlayoutData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                perfLogger.measure(PerfKey.root, PerfTag.preparingAdvertising);
                                if (!_this.adInsertionAddon && !_this.isNativeCsai) {
                                    return [
                                        2,
                                        initialPlayoutData
                                    ];
                                }
                                return [
                                    4,
                                    _this.populatePlayoutData(initialPlayoutData, sessionItem)
                                ];
                            case 1:
                                populatedPlayoutData = _state.sent();
                                return [
                                    2,
                                    populatedPlayoutData
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "buildVacRequestOptions",
            value: function buildVacRequestOptions(playoutData, sessionItem) {
                var _sessionItem_vac, _this_sessionItem_vac, _this_sessionItem;
                // The playout rectangle does not exist during prefetch time
                // the only purpose of this is for pause ads
                // the mobile team just passes the full screen dimensions for prefetch
                // So this is essentially just a static 1080p resolution dimension
                var playoutRect = {
                    x: 0,
                    y: 0,
                    width: 1920,
                    height: 1080
                };
                var propositionExtensions = CoreVideoInternal.getPropositionExtensions();
                var deviceCapabilities = propositionExtensions.devicePlaybackCapabilities;
                var _sessionItem_vac_durationMs, _this_sessionItem_vac_durationMs, _sessionItem_isMultiview;
                return _object_spread_props(_object_spread({
                    // CoreVideoSdk
                    sdkName: CoreVideoInternal.sdkName,
                    sdkVersion: CoreVideoInternal.version,
                    // Player
                    playerVersion: CoreVideoInternal.playerVersion,
                    playerDimensions: playoutRect,
                    isMiniPlayer: sessionItem.isMiniPlayer,
                    // Device
                    deviceType: CoreVideoInternal.deviceType,
                    deviceModel: CoreVideoInternal.deviceInfo.deviceModel,
                    deviceVersion: CoreVideoInternal.deviceInfo.deviceVersion || CoreVideoInternal.deviceInfo.browserVersion,
                    // Playout data
                    adServerContentId: playoutData.advertising.contentId,
                    cdnName: playoutData.cdns[0].name,
                    // TODO: How can we be sure this is the right CDN?
                    adCompatibilityEncodingProfile: playoutData.advertising.adCompatibilityEncodingProfile,
                    playbackType: playoutData.type,
                    streamingProtocol: playoutData.stream.protocol,
                    // Client data
                    mvpdHash: 'D2C'
                }, // Defaulting to this value, but expected to be overridden by client
                sessionItem.vac), {
                    httpUserAgent: getUserAgent(self),
                    durationMs: (_sessionItem_vac_durationMs = (_sessionItem_vac = sessionItem.vac) === null || _sessionItem_vac === void 0 ? void 0 : _sessionItem_vac.durationMs) !== null && _sessionItem_vac_durationMs !== void 0 ? _sessionItem_vac_durationMs : playoutData.durationMs,
                    // @ts-ignore: this property does NOT exists in Vam.RequestOptions
                    videoDurationInSeconds: (_this_sessionItem_vac_durationMs = (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_vac = _this_sessionItem.vac) === null || _this_sessionItem_vac === void 0 ? void 0 : _this_sessionItem_vac.durationMs) !== null && _this_sessionItem_vac_durationMs !== void 0 ? _this_sessionItem_vac_durationMs : playoutData.durationMs / 1000,
                    // Ad Insertion Config
                    adProvider: this.adInsertionConfig.adProvider,
                    slePreRoll: this.getSlePreRoll(deviceCapabilities, playoutData, sessionItem),
                    isPrefetch: Boolean(this.isPrefetch),
                    isMultiview: (_sessionItem_isMultiview = sessionItem.isMultiview) !== null && _sessionItem_isMultiview !== void 0 ? _sessionItem_isMultiview : false,
                    mvtOptimizelyHeadersForBackends: sessionItem.mvtOptimizelyHeadersForBackends
                });
            }
        },
        {
            key: "getSlePreRoll",
            value: function getSlePreRoll(deviceCapabilities, playoutData, sessionItem) {
                var slePreRoll = Boolean(deviceCapabilities.slePrerollSupported && playoutData.vamPrerollEnabled);
                if (sessionItem.isMultiview || sessionItem.slePrerollEnabled === false || /* by default they should be enabled, but we don't want to enforce this is specified */ checkIsSessionItemSleAutoplayType(sessionItem)) {
                    slePreRoll = false;
                }
                if (TestingOverrides.forceSlePreroll === 'Enabled') {
                    slePreRoll = true;
                } else if (TestingOverrides.forceSlePreroll === 'Disabled') {
                    slePreRoll = false;
                }
                return slePreRoll;
            }
        },
        {
            key: "populatePlayoutData",
            value: function populatePlayoutData(playoutData, sessionItem) {
                var _this = this;
                return _async_to_generator(function() {
                    var advertisingData, populatedPlayoutData, vacRequestOptions, _this_vacAddon, nativeCsaiVac, _this_adInsertionAddon, response, e, status, message, warning;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                advertisingData = _object_spread({}, playoutData.advertising);
                                populatedPlayoutData = _object_spread_props(_object_spread({}, playoutData), {
                                    advertising: advertisingData
                                });
                                if (!_this.isVacEnabled) return [
                                    3,
                                    9
                                ];
                                vacRequestOptions = _this.buildVacRequestOptions(playoutData, sessionItem);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    ,
                                    8
                                ]);
                                if (!_this.isNativeCsai) return [
                                    3,
                                    3
                                ];
                                perfLogger.measure(PerfKey.vac, PerfTag.vacRequest);
                                perfLogger.measure(PerfKey.root, PerfTag.vacRequest);
                                _this.session.updateTelemetryMetrics({
                                    key: TelemetryNotificationKey.vacRequestStart,
                                    value: new Date().getTime()
                                });
                                return [
                                    4,
                                    (_this_vacAddon = _this.vacAddon) === null || _this_vacAddon === void 0 ? void 0 : _this_vacAddon.fetchVacResponse(vacRequestOptions)
                                ];
                            case 2:
                                nativeCsaiVac = _state.sent();
                                _this.session.updateTelemetryMetrics({
                                    key: TelemetryNotificationKey.vacResponseEnd,
                                    value: new Date().getTime()
                                });
                                perfLogger.measure(PerfKey.vac, PerfTag.vacResponse);
                                perfLogger.measure(PerfKey.root, PerfTag.vacResponse);
                                populatedPlayoutData.custom = Object.assign({}, populatedPlayoutData.custom, {
                                    vac: nativeCsaiVac
                                });
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                if (!populatedPlayoutData.advertising) return [
                                    3,
                                    5
                                ];
                                perfLogger.measure(PerfKey.vac, PerfTag.vacRequest);
                                perfLogger.measure(PerfKey.root, PerfTag.vacRequest);
                                _this.session.updateTelemetryMetrics({
                                    key: TelemetryNotificationKey.vacRequestStart,
                                    value: new Date().getTime()
                                });
                                return [
                                    4,
                                    (_this_adInsertionAddon = _this.adInsertionAddon) === null || _this_adInsertionAddon === void 0 ? void 0 : _this_adInsertionAddon.prepareAdvertising(vacRequestOptions)
                                ];
                            case 4:
                                response = _state.sent();
                                _this.session.updateTelemetryMetrics({
                                    key: TelemetryNotificationKey.vacResponseEnd,
                                    value: new Date().getTime()
                                });
                                perfLogger.measure(PerfKey.vac, PerfTag.vacResponse);
                                perfLogger.measure(PerfKey.root, PerfTag.vacResponse);
                                if (response) {
                                    populatedPlayoutData.advertising.vac = response;
                                    _this.notifyCompanionAdInsertionEnabled(_this.shouldEnableCompanionAdInsertion(response));
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _this.logger.warn('Missing Advertising Data');
                                _state.label = 6;
                            case 6:
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                e = _state.sent();
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Type of error is always unknown
                                status = e.status, message = e.message;
                                warning = CvsdkError.from({
                                    code: 'SDK.ADVERTSMGR.SETUP_ADS',
                                    message: 'Failed to fetch VAC',
                                    severity: ErrorSeverity.Warning,
                                    cause: e
                                });
                                _this.logger.warn(warning);
                                _this.session.notifyWarning("".concat(warning.code, ".VAM_").concat(status !== null && status !== void 0 ? status : 'UNKNOWN'), message || 'Unknown error occurred');
                                // TODO: NBCU VAC specific logic should be shifted to the VAC Addon
                                // https://github.com/sky-uk/core-video-team/issues/7817
                                if (status === 204) {
                                    populatedPlayoutData.adsFailoverReason = AdsFailoverReason.Coppa;
                                } else {
                                    populatedPlayoutData.adsFailoverReason = AdsFailoverReason.Vam;
                                }
                                populatedPlayoutData.vamFailureStatus = status;
                                if (!status) {
                                    // Blocking request on dev tools yields status as undefined. keep it at 500 for consistency
                                    populatedPlayoutData.vamFailureStatus = 500;
                                }
                                return [
                                    2,
                                    populatedPlayoutData
                                ];
                            case 8:
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                populatedPlayoutData.advertising.custom = _object_spread({}, advertisingData.custom, _this.getCustomAdvertisingReportingData(sessionItem));
                                _state.label = 10;
                            case 10:
                                populatedPlayoutData.adInsertionConfig = _this.adInsertionConfig;
                                return [
                                    2,
                                    populatedPlayoutData
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCustomAdvertisingReportingData",
            value: function getCustomAdvertisingReportingData(sessionItem) {
                var _this_adInsertionClientConfig, _sessionItem_user_ids_yospace, _sessionItem_user_ids, _sessionItem_user;
                var _this_adInsertionClientConfig_yospace;
                var _ref = (_this_adInsertionClientConfig_yospace = (_this_adInsertionClientConfig = this.adInsertionClientConfig) === null || _this_adInsertionClientConfig === void 0 ? void 0 : _this_adInsertionClientConfig.yospace) !== null && _this_adInsertionClientConfig_yospace !== void 0 ? _this_adInsertionClientConfig_yospace : {}, siteSection = _ref.siteSection, fwVcid2 = _ref.fwVcid2;
                var userId = sessionItem === null || sessionItem === void 0 ? void 0 : (_sessionItem_user = sessionItem.user) === null || _sessionItem_user === void 0 ? void 0 : (_sessionItem_user_ids = _sessionItem_user.ids) === null || _sessionItem_user_ids === void 0 ? void 0 : (_sessionItem_user_ids_yospace = _sessionItem_user_ids.yospace) === null || _sessionItem_user_ids_yospace === void 0 ? void 0 : _sessionItem_user_ids_yospace.profileid;
                return {
                    csid: siteSection,
                    vcid2: "".concat(fwVcid2, ":").concat(userId)
                };
            }
        },
        {
            key: "notifyCompanionAdInsertionEnabled",
            value: function notifyCompanionAdInsertionEnabled(shouldEnableCompanionAdInsertion) {
                this.session.notifyCompanionAdInsertionEnabled(shouldEnableCompanionAdInsertion);
            }
        },
        {
            key: "shouldEnableCompanionAdInsertion",
            value: function shouldEnableCompanionAdInsertion(vacResponse) {
                if (!vacResponse || !vacResponse.keyValues) {
                    return false;
                }
                var _vacResponse_keyValues = vacResponse.keyValues, bl_enabled = _vacResponse_keyValues.bl_enabled, fa_enabled = _vacResponse_keyValues.fa_enabled, ma_enabled = _vacResponse_keyValues.ma_enabled;
                if (bl_enabled && bl_enabled === 'true' && (fa_enabled && fa_enabled === 'true' || ma_enabled && ma_enabled === 'true')) {
                    return true;
                }
                return false;
            }
        }
    ]);
    return AdvertsVacStageManager;
}();

//# sourceMappingURL=adverts-vac-stage-manager.js.map